import React from "react";
import videojs from "video.js";
import { calculateWidthAndHeightOffset } from "../../../Helpers/Utility";
import { ChatAudioSender2, ChatAudioRecorder } from "../../../assets/images";
import PropTypes from "prop-types";

export default class VideoPlayer extends React.Component {
  constructor() {
    super();
    this.state = {
      visibility: false,
      webWidth: 0,
      webHeight: 0,
      palyStatus: true
    };
  }

  componentDidMount() {
    // instantiate Video.js
    this.player = videojs(this.videoNode, this.props, () => {
      const videoElement = document?.querySelector(".vjs-tech");
      const parentElement = document?.getElementById(`video-player-${this.props.msgId}`);
      const captionElement = document?.getElementById(`video-caption-${this.props.msgId}`);

      if (parentElement) {
        const { offsetWidth, offsetHeight } = parentElement;
        let captionHeight = 0;
        if (captionElement) captionHeight = captionElement.offsetHeight + this.props.captionMargin;
        const { webWidth: newWidth, webHeight: newHeight } = calculateWidthAndHeightOffset(
          this.props.webWidth,
          this.props.webHeight,
          offsetWidth,
          offsetHeight - captionHeight
        );
        this.setState({
          webWidth: newWidth,
          webHeight: newHeight,
          visibility: true
        });
      }
      if (videoElement && this.props.handlePlay) {
        videoElement.addEventListener("play", () => this.props.handlePlay(true));
        videoElement.addEventListener("pause", () => this.props.handlePlay(false));
      }
    });
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
      const callElement = document.getElementById("webrtc-call-screen");
      if (callElement) {
        const videoElements = callElement.querySelectorAll("video");
        if (videoElements.length) {
          videoElements.forEach((el) => {
            el.play();
          });
        }
      }
    }
  }

  getStyle = () => {
    const { webWidth, webHeight, visibility } = this.state;
    return {
      width:"100%",
      height:"100%",
      maxWidth: `${webWidth}px`,
      maxHeight: `${webHeight}px`,
      visibility: visibility ? "visible" : "hidden"
    };
  };

  _onClick = () => {
    const { palyStatus } = this.state;
    if (palyStatus) {
      this.player.pause();
      this.setState({ palyStatus: false });
    } else {
      this.setState({ palyStatus: true });
      this.player.play();
    }
  };

  myCallback = () => {
    this.setState({ palyStatus: false });
    const elemsData = document.querySelectorAll(".AudioDetails");
    [].forEach.call(elemsData, function (ele) {
      ele.classList.remove("default");
    });
  };

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    const { palyStatus = true, visibility = false } = this.state;
    const { deleteOption = false, msgId, autoPlay, fileType = "" } = this.props;
    return (
      <div
        data-jest-id="jest_onClick"
        role={fileType === "audio" ? "button" : undefined}
        tabIndex={fileType === "audio" ? 0 : undefined}
        onClick={fileType === "audio" ? () => this._onClick() : null}
        onKeyDown={fileType === "audio" ? (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this._onClick();
          }
        } : undefined}
      >
        {fileType === "audio" && (
          <i className={`AudioDetails ${palyStatus === true ? "default" : ""}`}>
            {this.props.audioType !== "recording" ? <ChatAudioSender2 /> : <ChatAudioRecorder />}
            <span className="audioDuration">{this.props.audioDuration}</span>
          </i>
        )}

        {deleteOption && <div className="uploadImagePreview"></div>}
        <div style={this.props.fileType === "video" ? this.getStyle() : {}} data-vjs-player>
        <img style={{visibility : visibility ? "hidden" : "visible"}} src={this.props.thumb_image} className="data" alt={this.props.fileName} />
          <video
            preload="auto"
            data-msgid={msgId}
            autoPlay={autoPlay}
            className="video-js"
            onEnded={() => this.myCallback()}
            ref={(node) => (this.videoNode = node)}
          >
             <track kind="captions" src="" label="English captions" />
          </video>
        </div>
      </div>
    );
  }
}

VideoPlayer.propTypes = {
  msgId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  autoPlay: PropTypes.bool,
  fileType: PropTypes.string,
  audioType: PropTypes.string,
  audioDuration: PropTypes.string,
  thumb_image: PropTypes.string,
  fileName: PropTypes.string,
  deleteOption: PropTypes.bool,
  webWidth: PropTypes.number,
  webHeight: PropTypes.number,
  captionMargin: PropTypes.number,
  handlePlay: PropTypes.func
};